import { platformWeb } from "../../utils";
import { DrawerScreenProps } from "@react-navigation/drawer";
import { ParamListBase } from "@react-navigation/native";
import { Center, ScrollView, VStack } from "native-base";
import { Content } from "./Components/Content";
import { BottomNavigation, TemplateWebPages } from "../../components";

export const NewDashboardScreen = ({ route, navigation }: DrawerScreenProps<ParamListBase>) => {
  return (
    <>
      <VStack flex={1}>
        {platformWeb ? (
          <ScrollView>
            <TemplateWebPages navigation={navigation}>
              <Center>
                <Content route={route} navigation={navigation} />
              </Center>
            </TemplateWebPages>
          </ScrollView>
        ) : (
          <>
            <ScrollView>
              <Content route={route} navigation={navigation} />
            </ScrollView>
            <BottomNavigation navigation={navigation} />
          </>
        )}
      </VStack >
    </>
  )
}